import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import SignUp from './components/Signup/Signup';
import Login from './components/Login/Login';

import Footer from './components/Footer/footer';
import Navbar from './components/Navbar/Navbar';
import Home from './components/Home/Home';
import Dashboard from './components/Dashboard/Dashboard';
import Contact from './components/Contact/Contact';
import PasswordResetRequest from './components/PasswordResetReques/PasswordResetRequest';
import PasswordResetVerify from './components/PasswordResetVerify/PasswordResetVerify';
import PasswordReset from './components/PasswordReset/PasswordReset';
import HeroSection from './components/HeroSection/HeroSection';
import ComingSoonAppSection from './components/ComingSoonAppSection/ComingSoonAppSection';
import FeaturesSection from './components/FeaturesSection/FeaturesSection';
import HowItWorks from './components/HowItWorks/HowItWorks';
import AmbassadorPromoSection from './components/AmbassadorPromoSection/AmbassadorPromoSection';
import PrivacyPolicy from './components/PrivacyPolicy/PrivacyPolicy';
import AboutUs from './components/AboutUs/AboutUs';
import AmbassadorProgram from './components/AmbassadorPromogram/AmbassadorProgram';
import AmbassadorRegister from './components/AmbassadorRegister/AmbassadorRegister';
import OtpVerification from './components/OtpVerification/OtpVerification';
import PharmacyProfile from './components/PharmacyProfile/PharmacyProfile';
import PharmacyVerificationForm from './components/PharmacyVerificationForm/PharmacyVerificationForm'
import UpdatePharmacyProfile from './components/UpdatePharmacyProfile/UpdatePharmacyProfile'
import ManagePharmacyBranch from './components/ManagePharmacyBranch/ManagePharmacyBranch'
import Sidebar from './components/Sidebar/Sidebar'; 
import CreatePharmacyBranch from './components/CreatePharmacyBranch/CreatePharmacyBranch'
import PharmacyBranches from './components/PharmacyBranches/PharmacyBranches'
import ManageInventory from './components/ManageInventory/ManageInventory'
import AddInventoryManually from './components/AddInventoryManually/AddInventoryManually'
import UploadInventoryCSV from './components/UploadInventoryCSV/UploadInventoryCSV'
import InventoryItem from './components/InventoryItem/InventoryItem'
import UpdateInventoryCSV from './components/UpdateInventoryCSV/UpdateInventoryCSV'
import UpdateInventoryManually from './components/UpdateInventoryManually/UpdateInventoryManually'

function App() {
  return (
    <Router>
      <div className="app-container">
        <Navbar />
        <div className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/login" element={<Login />} />
            <Route path="/UpdateInventoryCSV" element={<UpdateInventoryCSV />} />
            <Route path="/UpdateInventoryManually" element={<UpdateInventoryManually />} />
            <Route path="/PharmacyVerificationForm" element={<PharmacyVerificationForm />} />
            <Route path="/InventoryItem" element={<InventoryItem />} />
            <Route path="/AddInventoryManually" element={<AddInventoryManually />} />
            <Route path="/UploadInventoryCSV" element={<UploadInventoryCSV />} />
            <Route path="/PharmacyBranches" element={<PharmacyBranches />} />
            <Route path="/ManageInventory" element={<ManageInventory />} />
            <Route path="/Sidebar" element={<Sidebar />} />
            <Route path="/ManagePharmacyBranch" element={<ManagePharmacyBranch />} />
            <Route path="/UpdatePharmacyProfile" element={<UpdatePharmacyProfile />} />
            <Route path="/CreatePharmacyBranch" element={<CreatePharmacyBranch />} />
            <Route path="/PharmacyProfile" element={<PharmacyProfile />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/AboutUs" element={<AboutUs />} />
            <Route path="/AmbassadorProgram" element={<AmbassadorProgram />} />
            <Route path="/AmbassadorRegister" element={<AmbassadorRegister />} />
            <Route path="/OtpVerification" element={<OtpVerification />} />
            <Route path="/AmbassadorPromoSection" element={<AmbassadorPromoSection />} />
            <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
            <Route path="/HowItWorks" element={<HowItWorks />} />
            <Route path="/RegularSubscription" element={<FeaturesSection />} />
            <Route path="/HeroSection" element={<HeroSection />} />
            <Route path="/PasswordResetVerify" element={<PasswordResetVerify />} />
            <Route path="/ComingSoonAppSection" element={<ComingSoonAppSection />} />
            <Route path="/PasswordReset" element={<PasswordReset />} />
            <Route path="/PasswordResetRequest" element={<PasswordResetRequest />} />
            <Route path="/Contact" element={<Contact />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
